import { header } from './header';
import { showCaseContent } from './showCaseContent';
import { contactList } from './contactList';
import { aboutMe } from './aboutMe';
import { ocupation } from './ocupation';
import { skills } from './skills';
import { projects } from './projects';

export default {
	translations: {
		home: {
			header,
			showCaseContent,
			contactList,
			aboutMe,
			ocupation,
			skills,
			projects,
		},
	},
};
